import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Field } from "@/components/ListingFormSections";

export const DEFAULT_POLICY = "strict";

export function usePolicies() {
  return useQuery({ queryKey: ["cancellation-policies"], queryFn: () => api.get("/cancellation-policies").then((r) => r.data), staleTime: Infinity });
}

export function PolicyText({ policyKey }) {
  const { data = [] } = usePolicies();
  const p = data.find((x) => x.key === (policyKey || DEFAULT_POLICY));
  if (!p) return null;
  return <><span className="font-semibold">{p.name} cancellation:</span> {p.text}</>;
}

// Homeowners pick one of FairStay's approved policies; guests see it before booking.
export function CancellationPolicySection({ form }) {
  const { f, set } = form;
  const { data = [] } = usePolicies();
  return (
    <Field label="Cancellation policy">
      <div className="grid gap-3 sm:grid-cols-3" data-testid="listing-cancellation-policy">
        {data.map((p) => (
          <label key={p.key} className={`cursor-pointer rounded-2xl border p-4 text-sm transition-colors ${f.cancellation_policy === p.key ? "border-primary bg-primary/5" : "hover:bg-stone-50"}`} data-testid={`listing-policy-${p.key}`}>
            <input type="radio" name="cancellation_policy" value={p.key} checked={f.cancellation_policy === p.key} onChange={set("cancellation_policy")} className="sr-only" />
            <p className="font-semibold">{p.name}</p>
            <p className="mt-1 text-stone-600">{p.text}</p>
          </label>
        ))}
      </div>
      <p className="mt-2 text-xs text-stone-500">FairStay handles refunds under this policy, and may fully refund guests if a home is fraudulent, unavailable or unsafe.</p>
    </Field>
  );
}
